export const GET_PLV_WATCH_LINK_SUCCESS = 'GET_PLV_WATCH_LINK_SUCCESS';
export const LOADING_MESSAGE = '请稍等...';
